import React from "react";

const getHeader = track => {
  return track === "myself"
    ? " Concerns for Myself"
    : track === "caregiver"
    ? " Concerns for Someone Else"
    : "";
};
const QuestionHeader = ({ track }) => {
  const headerText = getHeader(track);
  return <div className={`track ${track}`}>{track && <p>{headerText}</p>}</div>;
};

export default QuestionHeader;
